export const SLOT_TITLE = 'Loja Integrada';
export const TEST_ID = 'loja-integrada-integration';
export const APPCUES_ID = 'loja-integrada-slot';
export const MODAL_TITLE = 'Loja Integrada';
export const MODAL_SUBTITLE_INITIAL = 'Learn how to find your token ';
export const MODAL_SUBTITLE_FINAL = 'here';
export const API_TOKEN_LINK = 'https://ajuda.lojaintegrada.com.br/pt-BR/articles/931152-gerando-chave-api-e-chave-de-aplicacao';

export const API_GET_DATA_URL = '/api/get-loja-integrada-api-token';
export const API_INTEGRATE_URL = '/api/integrate-loja-integrada';
export const API_SUCCESS_OP_MESSAGE = 'Api Token Successfully Saved.';
export const API_FAIL_DEFAULT_OP_MESSAGE = 'Unknown Error';
